import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=4517c777&scoped=true&"
import script from "./ListNotifications.vue?vue&type=script&lang=js&"
export * from "./ListNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ListNotifications.vue?vue&type=style&index=0&id=4517c777&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4517c777",
  null
  
)

export default component.exports